<template>
  <div class="questionnaire-question-content">
    <div class="questionnaire-question-sentence">
      {{ this.statement }}
      <div class="questionnaire-question-image" @click.prevent="playSound()">
        <img src="@/assets/img/listen.png">
      </div>
    </div>

    <div class="questionnaire-question-question">
      {{ this.question }}
    </div>

    <div v-for="proposition of propositions" :key="proposition.label">
      <div v-if="this.answer != undefined && this.answer.includes(proposition)" :value=proposition class="col-md-8 questionnaire-question-proposition-selected" tabindex="0" v-on:click="focus">
        <div class="questionnaire-question-proposition-choix">
          {{ proposition }}
        </div>
      </div>
      <div v-else :value=proposition class="col-md-8 questionnaire-question-proposition" tabindex="0" v-on:click="focus">
        <div class="questionnaire-question-proposition-choix">
          {{ proposition }}
        </div>
      </div>
    </div>
    <div v-if="audioCurrentTime !== '' && audioCurrentTime != null" class="questionnaire-question-question"><br/>Durée de l'audio : {{ audioCurrentTime }} / {{ audioDuration }} s</div>
  </div>
</template>

<script>
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "ExpressionQuestionMultipleCheckboxWithAudio",
  props: {
    question: String,
    statement: String,
    previousStatement: String,
    propositions: Array,
    title: String,
    audio: String
  },
  data() {
    return {
      ifFirstPage: true,
      answer: null,
      audioDuration: '',
      audioCurrentTime: ''
    }
  },
  methods: {
    focus: function (event) {
      event.currentTarget.classList.toggle("questionnaire-question-proposition-selected");
      var answersTmp = [];
      var elements = document.getElementsByClassName('questionnaire-question-proposition-selected')
      Array.prototype.forEach.call(elements, function (el) {
        answersTmp.push(el.getAttribute('value'));
      });
      this.answer = answersTmp
    },
    disableClick: function (time) {
      time = time * 1000
      var element = document.getElementById('questionContent');
      element.classList.add('questionnaire-question-disable');
      setTimeout(
          function () {
            element.classList.remove('questionnaire-question-disable');
          }, time
      )
    },
    playSound() {
      var audioInstance = new Audio(require('@/assets/sounds/' + this.audio));
      var _ = this;

      audioInstance.addEventListener('loadedmetadata', function () {
        audioInstance.setAttribute('data-time', audioInstance.duration);
        _.audioDuration = audioInstance.duration.toFixed(1);
      }, false);

      audioInstance.play().then(() => {
        this.disableClick(audioInstance.duration)
        this.$parent.remainingTime = this.$parent.remainingTime + Math.floor(audioInstance.duration)
        this.$parent.saveListen(this.$parent.listen)
      });

      audioInstance.addEventListener("timeupdate", function () {
        _.audioCurrentTime = (audioInstance.currentTime % 60).toFixed(1);
      }, false);

    },
  },
  mounted() {
    var domainId = this.$parent.domainId
    var indexQuestion = this.$parent.indexQuestion

    UserService.getUserTestQuestions(domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) this.answer = arrayResponses[index]['answer']

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
